import React, { useState } from "react";
import moment from "moment";
import { FiLock } from "react-icons/fi";
import { withUser } from "../Contexts/user";
import PerformanceReportView from "../Components/PerformanceReportView";

const capitalizeWords = (str) =>
    (str || "")
        .toLowerCase()
        .split(" ")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

const getDisplayName = (nickname, name) => {
    const cleanNickname = nickname && nickname.trim() !== "-" ? nickname : "";
    return capitalizeWords(`${cleanNickname} ${name || ""}`);
};

const getDefaultFilters = () => ({
    project: null,
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateTo: moment().endOf("month").format("YYYY-MM-DD"),
    state: null,
});

const SDReport = ({ user }) => {
    const [filters, setFilters] = useState(getDefaultFilters);
    const { director, userId, name, nickname } = user.auth;

    if (director === undefined) {
        return (
            <div className="sd-report my-10 lg:my-0 lg:p-8">
                <div className="sd-report-card sd-report-empty">
                    <div className="sd-report-spinner" />
                    <span>Loading...</span>
                </div>
            </div>
        );
    }

    if (director !== "SD") {
        return (
            <div className="sd-report my-10 lg:my-0 lg:p-8">
                <div className="sd-report-card sd-report-empty">
                    <FiLock size={28} color="#5a5080" aria-hidden />
                    <span className="font-semibold text-gray-900">Access restricted</span>
                    <span>The SD Report is only available to Sales Directors.</span>
                </div>
            </div>
        );
    }

    const periodFilterSection = (
        <>
            <div className="sd-report-field">
                <label className="sd-report-label">Date From</label>
                <input
                    className="sd-report-input"
                    type="date"
                    max={filters.dateTo || undefined}
                    onChange={(e) => {
                        setFilters((prev) => ({
                            ...prev,
                            dateFrom: e.target.value,
                        }));
                    }}
                    value={filters.dateFrom}
                />
            </div>
            <div className="sd-report-field">
                <label className="sd-report-label">Date To</label>
                <input
                    className="sd-report-input"
                    type="date"
                    min={filters.dateFrom || undefined}
                    onChange={(e) => {
                        setFilters((prev) => ({
                            ...prev,
                            dateTo: e.target.value,
                        }));
                    }}
                    value={filters.dateTo}
                />
            </div>
        </>
    );

    return (
        <PerformanceReportView
            title="SD Report"
            description="Sales and conversion performance across your team's projects"
            bannerTitle="ANNUAL SALES & CONVERSION RATE"
            dateFrom={filters.dateFrom}
            dateTo={filters.dateTo}
            filters={filters}
            setFilters={setFilters}
            salesDirectorId={userId}
            salesDirectorName={getDisplayName(nickname, name)}
            periodFilterSection={periodFilterSection}
            onResetFilters={() => setFilters(getDefaultFilters())}
        />
    );
};

export default withUser(SDReport);
